import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ErrorModel } from '../api';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  private getControl(formToValidate, controlName) {
    controlName.split('.').forEach(name => {
      if (formToValidate === null) {
        return null;
      }

      formToValidate = formToValidate.get(name);
    });

    return formToValidate;
  }

  public markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if ((control as any).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }

  public serverValidateForm(formToValidate: FormGroup, err: ErrorModel, errorMap = null) {
    this.markFormGroupTouched(formToValidate);

    err.errors && Object.keys(err.errors).forEach(key => {
      const controlName = errorMap ? errorMap[key] : key;

      if (!!controlName) {
        const msg = err.errors[key][0];
        const control = this.getControl(formToValidate, controlName);

        control && control.setErrors({ [msg]: true });
      }
    });
  }
}
